import { useContext, useEffect } from 'react';

import { CurrentUserContext } from '../providers/CurrentUserProvider';

const Signout = () => {
  const userData = useContext(CurrentUserContext);

  useEffect(() => {
    const signOutAndRedirectBack = async () => {
      await userData.signOut();
      if (typeof window !== 'undefined') {
        window.location.href = process.env.WP_APP_HOST;
      }
    };

    signOutAndRedirectBack();
  }, []);

  return null;
};

export default Signout;
